import EditProjects from './EditProjects';
export default EditProjects;
